// extracted by mini-css-extract-plugin
module.exports = {"page-heading":"PageHeading_page-heading__1fETr","page-heading-header":"PageHeading_page-heading-header__1kc3S","inner-flex":"PageHeading_inner-flex__1IgtL"};